export { default } from './Zccs';
export { default as reducer } from './Zccs.ducks';
export { default as sagas } from './Zccs.sagas';

import * as actions from './Zccs.ducks';
export { actions };
